import PropTypes from 'prop-types';
import { selector, selectorId } from 'selectors/payALoan';
import TransactAsButton from 'components/modules/service/PayerDetail/TransactAsButton';
import { Stack } from '@mui/material';
import { ReadOnlyFormControl } from 'components/common/fields';
import { filterByDDA, TRANSACTION_TYPE_PAL } from 'consts';
import { useSelector } from 'react-redux';
import { transactOnBehalfPalOnSelector } from 'selectors/userFspConfig';
import { useIsLoading } from 'hooks';
import { LOAD } from 'model/payALoan';
import LoanNumberMask from '../../Accounts/Internal/config/LoanNumberMask';
import PayALoanAudit from '../PayALoanAudit';

const ActionsRenderer = ({ item }) => {
  const showTransactOnBehalf = useSelector((state) =>
    transactOnBehalfPalOnSelector(state, item?.fspId, item?.payerId)
  );
  const stmtItems = useSelector((state) => selector(state));
  const isStatementsLoading = useIsLoading(LOAD);
  const stmtId = filterByDDA(item, stmtItems ?? [])[0]?.id;
  const auditItem = stmtId ? { ...item, stmtId } : item;

  return (
    <Stack direction="row" spacing={1}>
      <ReadOnlyFormControl
        inputNode={<LoanNumberMask item={item} />}
        label="Loan #"
        value={item.accountNbrMask}
      />
      {showTransactOnBehalf && (
        <TransactAsButton
          accountSuffix={item.accountSuffix}
          loanId={item.id}
          payerId={item.payerId}
          transactionType={TRANSACTION_TYPE_PAL}
          fspIdValue={item.fspId}
        />
      )}
      {!isStatementsLoading && stmtId ? (
        <PayALoanAudit item={auditItem} selectorId={selectorId} />
      ) : null}
    </Stack>
  );
};

ActionsRenderer.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ActionsRenderer;
